// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"35c9899a","923":"2e2927d6"}[chunkId] + ".chunk.css";
};